// javascript
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCube, Mousewheel } from 'swiper/modules';
import React, { useRef, useMemo } from 'react';
import { l } from '../../../lang/index.jsx';
import Link from "../../menu-link/LinkHelper.jsx";
import ProjectsSlide from './ProjectsSlide.jsx';

export default function ProjectsSwiper({ navigate, lang, textMap, allProjects }) {
    const swiperRef = useRef(null);
    const t = (key) => textMap?.[key]?.[lang] || l(key, lang);

    const DATA = Array.isArray(allProjects) ? allProjects : [];

    const visibleData = DATA.filter(item => item?.swiperShow === true);

    const shuffleArray = (array) => {
        const arr = Array.isArray(array) ? array.slice() : [];
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
        return arr;
    };

    const shuffledData = useMemo(() => shuffleArray(visibleData), [visibleData]);

    const prevSlide = (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        if (swiperRef.current && typeof swiperRef.current.slidePrev === 'function') {
            swiperRef.current.slidePrev();
        }
    };

    const nextSlide = (e) => {
        if (e && typeof e.preventDefault === 'function') e.preventDefault();
        if (swiperRef.current && typeof swiperRef.current.slideNext === 'function') {
            swiperRef.current.slideNext();
        }
    };

    return (
        <div className='section section-projects' id='nextSection'>
            <h2 className="h2">{t('home-projects-title')}</h2>

            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{position: 'absolute', width: 0, height: 0, left: 0}}>
                <defs>
                    <clipPath id="concaveClip" clipPathUnits="objectBoundingBox">
                        <path d="M0 0 C0.25 0.07 0.75 0.07 1 0 L1 1 C0.75 0.93 0.25 0.93 0 1 Z" />
                    </clipPath>
                </defs>
            </svg>

            <div className="swiper-container">
                {shuffledData.length > 0 && (
                    <Swiper
                        modules={[Navigation, EffectCube, Mousewheel]}
                        className="mySwiper"
                        slidesPerView='1'
                        centeredSlides={true}
                        spaceBetween='20px'
                        loop={true}
                        speed={600}
                        onSwiper={(s) => { swiperRef.current = s; }}
                        breakpoints={{
                            768: { slidesPerView: 1.4 },
                            1024: { slidesPerView: 1.3 }
                        }}
                    >
                        {shuffledData.map((d, i) => (
                            <SwiperSlide key={d?.slug ?? i}>
                                <ProjectsSlide navigate={navigate} data={d} lang={lang}/>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}
                <div className='nav-swiper'>
                    <a
                        href="#"
                        className={`picto prev`}
                        onClick={prevSlide}
                        aria-label="Previous project"
                    >
                        <div className="arrow-container">
                            <svg className="arrow-down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                            </svg>
                        </div>
                    </a>
                    <a
                        href="#"
                        className={`picto next`}
                        onClick={nextSlide}
                        aria-label="Next project"
                    >
                        <div className="arrow-container">
                            <svg className="arrow-down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                            </svg>
                        </div>
                    </a>
                </div>
            </div>

            <div className='more-projects'>
                <Link navigate={navigate} aria-label="See the projects page" className='button' href={'/' + 'projects'}>
                    <span>{t('home-projects-button')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                    </svg>
                </Link>
            </div>
        </div>
    )
}
